module.exports = __webpack_public_path__ + "media/assets/images/votorantim-cimentos@2x-47ce8e4356f12f4ea57b4ec87aa9f299.png";